export default (state, action) => {
    if (action.data && Object.keys(action.data).length) {
        return Object.assign({}, state, {
            header: action.data.header,
            rows: action.data.rows,
            selectedRows: [],
            meta: {
                currencies: action.data.meta ? action.data.meta.currencies : []
            },
            loading: false,
            initialized: true
        });
    }
    return Object.assign({}, state, {
        loading: false,
        initialized: true
    });
};



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/reducers/importData.js